<div
	class="input__container"
	[ngClass]="{
		'input__container--no_border': !border
	}"
>
	<div *ngIf="icon || featuredEnabled" class="input__container__icon_container">
		<i class="input__container__icon_container__icon tagmeicon {{ icon }}"></i>
		<i
			*ngIf="featuredEnabled"
			class="input__container__icon_container__icon--valid tagmeicon tagmeicon-ok"
		></i>
	</div>
	<div class="input__container__input_container">
		<label class="input__container__input_container__label">{{ label }}</label>

		<app-intl-tel-input
			*ngIf="inputmode === 'tel'"
			ngClass="input__container__input_container__input"
			(phoneNumberChange)="onPhoneNumberChange($event)"
			(dispatchOnBlur)="onBlur(); onKeyUp()"
			(dispatchOnKeyUp)="onKeyUp()"
			[hasError]="hasError"
		></app-intl-tel-input>

		<input
			*ngIf="!currencyMask && inputmode !== 'tel'"
			class="input__container__input_container__input"
			type="{{ type }}"
			attr.inputmode="{{ inputmode }}"
			placeholder="{{ placeholder }}"
			[(ngModel)]="value"
			(blur)="onBlur()"
			(keyup)="onKeyUp()"
			(ngModelChange)="ngModelChange()"
			[autocomplete]="autocomplete"
			[mask]="mask"
			[appAutofocus]="autofocus"
			[thousandSeparator]="thousandSeparator"
			[dropSpecialCharacters]="false"
      [readOnly]="readonly"
		/>
		<input
			*ngIf="currencyMask"
			class="input__container__input_container__input"
			inputmode="decimal"
			placeholder="{{ placeholder }}"
			[(ngModel)]="value"
			(blur)="onBlur()"
			(keyup)="onKeyUp()"
			autocomplete="off"
			currencyMask
			[options]="{ prefix: 'R$ ', thousands: '.', decimal: ',', align: 'left' }"
      [readOnly]="readonly"
		/>
	</div>
	<div class="input__container__hint" *ngIf="hint && !value">
		<div class="input__container__hint__container">
			{{ hint }}
		</div>
	</div>
	<div class="input__container__hint" *ngIf="value && hasError && errorMsg">
		<div class="input__container__hint__container">
			{{ errorMsg }}
		</div>
	</div>
</div>
